<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      ><el-row :gutter="10">
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item label="项目分类" prop="prjCategoryCode">
            <dict-select
              v-model="formData.prjCategoryCode"
              url="/digitalCenter/common/dict/prjCategory"
              size="small"
              placeholder="请选择分类"
              style="width: 100%"
              disabled
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item label="字段类型" prop="prjInputColumnType">
            <el-select
              @change="columnTypeChange"
              v-model="formData.prjInputColumnType"
              style="width:100%"
              size="small"
              placeholder="请选择字段类型"
              :disabled="disabled"
              filterable
              clearable
            >
              <el-option label="文本框" value="text"></el-option>
              <el-option label="下拉框" value="select"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item label="属性类型名称" prop="prjInputColumnDisplay">
            <el-input
              v-model="formData.prjInputColumnDisplay"
              :disabled="disabled"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item label="属性类型" prop="prjInputColumnName">
            <dict-select
              v-if="formData.prjInputColumnType === 'select'"
              v-model="formData.prjInputColumnName"
              url="/digitalCenter/common/dict/prjAttribute"
              size="small"
              placeholder="请选择属性类型"
              style="width: 100%"
              :disabled="disabled"
              filterable
              clearable
            ></dict-select>
            <el-input
              v-else
              v-model="formData.prjInputColumnName"
              placeholder="请输入属性类型"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item label="是否可以多选" prop="isMultiselect">
            <el-radio-group style="width: 100%" size="small" :disabled="disabled" v-model="formData.isMultiselect">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item label="是否必输项" prop="isRequired">
            <el-radio-group style="width: 100%" size="small" :disabled="disabled" v-model="formData.isRequired">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item label="是否显示" prop="isVisible">
            <el-radio-group style="width: 100%" size="small" :disabled="disabled" v-model="formData.isVisible">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item label="排序" prop="sortOrder">
            <el-input
              type="number"
              v-model.number="formData.sortOrder"
              autocomplete="off"
              :disabled="disabled"
              placeholder="选填,不填系统自动生成"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="createDateVisible">
          <div style="font-size: 14px; color: #717171;">
            <span>Create：{{formData.createByName?formData.createByName:'--'}} at {{formData.createDate?formData.createDate:'--'}}</span>
            |
            <span>Modify：{{formData.modifyByName?formData.modifyByName:'--'}} at {{formData.modifyDate?formData.modifyDate:'--'}}</span>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from "@/libs/util.validate";
import EditLoading from "@/mixins/edit-loading";
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    createDateVisible: Boolean,
    prjTemplateCode: String,
    prjCategoryCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        isVisible: "Y",
        prjCategoryCode: this.prjCategoryCode,
        prjInputColumnType: "text",
      },
      rules: {
        prjCategoryCode: [
            { required: true, message: '请选择分类', trigger: 'blur' }
        ],
        prjInputColumnName: [
          { required: true, message: this.$l('form_rule_message_attribute_type')||'请输入或选择属性类型', trigger: 'blur' }
        ],
        prjInputColumnType: [
          { required: true, message: this.$l('form_rule_message_field_type')||'请选择字段类型', trigger: 'blur' }
        ],
        prjInputColumnDisplay: [
          { required: true, message: this.$l('form_rule_message_attribute_type_name')||'请输入属性类型名称', trigger: 'blur' },
          { max: 50, message: this.$l('form_rule_input_length_50')||'长度在50个字符以内', trigger: 'blur' }
        ]
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.prjTemplateCode) return;

      this.$api
        .prjInputTemplateDetailApi({
          prjTemplateCode: this.prjTemplateCode,
        })
        .then((res) => {
          this.formData = res.body;
        });
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) {
        return;
      }
      this.loadingOpen();
      this.$api
        .prjInputTemplateSaveApi(this.formData)
        .then((res) => {
          this.loadingClose();
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || res.msg,
            type: "success",
          });
          this.$emit("close");
          this.$emit("reload");
        })
        .catch(() => {
          this.loadingClose();
        });
    },
    cancel() {
      if (this.disabled) {
        this.close();
        return;
      }
      this.openQuestion();
    },
    close() {
      this.$emit("close");
    },
    openQuestion() {
      this.$confirm(
        this.$l("INDEX.tips_question_save") || "是否要保存更改",
        this.$l("INDEX.tips_question_title") || "提示信息",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l("INDEX.btn_save") || "保存",
          cancelButtonText: this.$l("INDEX.btn_no_save") || "不保存",
        }
      )
        .then(() => {
          this.save();
        })
        .catch((action) => {
          if (action === "cancel") {
            this.close();
          }
        });
    },
    columnTypeChange () {
      this.formData.prjInputColumnName = ''
    },
  },
};
</script>
